











import Vue from 'vue';
import upgradeVuex from '../vuex/common';
import Account from '../components/Account.vue';
import Level from '../components/Level.vue';
import ModuleV from '../components/Module.vue';
import TimeV from '../components/Time.vue';
import Fee from '../components/Fee.vue';
import More from '../components/More.vue';
import moment from 'moment';
import appClient from '../../apis';
import { FansLevel, Time, Module, SubscribeAccount, ServiceAccount} from '../models/Fee';
import accountClient from '../../account/apis';

export default Vue.extend({
  mixins: [upgradeVuex],
  components: {
    Account,
    Level,
    ModuleV,
    TimeV,
    Fee,
    More,
  },
  data() {
    return {
      Module,
      FansLevel,
      Time,
    };
  },
  watch: {
    'upgrade.level'() {
      if (this.upgrade.level !== FansLevel.Level4) {
        this.calFee();
      }
    },
    'upgrade.isAll'() {
      this.calFee();
    },
    'upgrade.modules'() {
      this.calFee();
    },
    'upgrade.time'() {
      this.calFee();
    },
    'accountState.changeAccountNum'() {
      this.calFee();
    },
    'upgrade.discount'() {
      this.calFee();
    },
  },
  methods: {
    calFee() {
      if (this.account.weixinType) {
        const tempModules = this.upgrade.isAll ? [Module.Customer, Module.Rule, Module.Mass] : this.upgrade.modules;
        const crmLevelUnit = {accountType: this.account.weixinType, modules: tempModules, followerLevel: this.upgrade.level };
        let discount = null;
        if (this.upgrade.discount) {
          const fdiscount = JSON.parse(this.upgrade.discount.discount);
          discount = {id: this.upgrade.discount.id, cutFee: fdiscount.Fixed.n};
        }
        accountClient.getUpgradeFee({
          after: crmLevelUnit,
          years: this.upgrade.time,
          upgradeFee: this.upgrade.fee,
          discount: discount,
          payMethod: this.upgrade.payType}).success((r) => {
          let price = r;
          this.$store.commit('UPDATE_FEE', price);
          this.$store.commit('UPDATE_PRE_PROMO_FEE', price);
          if (this.upgrade.promoFee) {
            price = price + this.upgrade.promoFee;
          }
          this.$store.commit('UPDATE_PRE_PROMO_FEE', price);
        });
      }
    },
    getDefaultDiscount() {
      accountClient.getDefaultDiscount({}).success((r) => {
        this.$store.commit('UPDATE_DEFAULT_DISCOUNT', r);
      });
    },
  },
  mounted() {
    this.getDefaultDiscount();
    if (this.account) {
      this.calFee();
    }
  },
});
